export class ImpossibleStateError extends Error {}
